import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMacintosh: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconMacintosh"><Path d="M13.75 15.25H16.25M5.75 17.5V20.25C5.75 20.8023 6.19772 21.25 6.75 21.25H17.25C17.8023 21.25 18.25 20.8023 18.25 20.25V17.5M7.75 5.75H16.25V12.25H7.75V5.75ZM4.75 15.25V5.75C4.75 4.09315 6.09315 2.75 7.75 2.75H16.25C17.9069 2.75 19.25 4.09315 19.25 5.75V15.25C19.25 16.9069 17.9069 18.25 16.25 18.25H7.75C6.09315 18.25 4.75 16.9069 4.75 15.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconMacintosh;
